<template>
  {{data}}
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Selenggara LN2" >
      <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column" >
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <tbody> 
                    <tr class="row_data">
                      <td><b>Tarikh </b></td>
                      <td><b>:</b></td>
                      <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>No. Tangki</b></td>
                      <td><b>:</b></td>
                      <td>{{data.no_tangki}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Sebelum (cm)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.seebelum}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Sesudah (cm)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.selepas}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Isipadu TOPUP (L)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.isipadu_topup_l}}</td>
                    </tr>
                    <tr class="row_data">
                      <td><b>Isipadu TOPUP (m³)</b></td>
                      <td><b>:</b></td>
                      <td>{{data.isipadu_topup_m}}</td>
                    </tr>
                    </tbody>
                  </table>
              
              </div>
            </div>
          </div>
        </div>
        
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import Pengambilan from './Show/Pengambilan.vue';

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'tangki.selenggara',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Tangki LN2', route: '/tangki' },
        { label: 'Selenggara Tangki LN2', route: '/tangki/selenggara' },
        { label: 'Papar', route: '/tangki/selenggara/'+this.id },
      ],
      data : {id : 0},
      
      tabs: [
      		  { title: 'Tangki Selenggara', content: '' },
          ]
    }
  },
  methods: {

    getData()
    {
      this.$zcomm.get(this.api_service + 'tangki_selenggara/show/'+this.id, {}).then(res => {
        this.data = res
        
        // this.listTabs()
      })

    },

   
   tutup(){
         this.$inertia.visit(window.route('tangki.selenggara.index'));
       },
   
   

   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
